import { Col, Modal, Row } from "react-bootstrap"
import { BeatLoader } from "react-spinners"
import { AssignmentResponse } from "shared/types/teacherTypes"
import styles from "./teacherSci35.module.scss"
import { useNavigate } from "react-router"
import { AssignmentPreviewStateProps } from "components/Lessons/Grading/AssignmentPreview/Preview"
import { CORE_IDEA_VIEW_OPEN_KEY } from "constants/generalConstants"
import { BlockType } from "shared/types/science35Types"
import { toProductString } from "helpers/blockStringConverter"

interface Props {
    show: boolean
    hide: () => void
    assignments: AssignmentResponse[]
    blockType: BlockType
}

const ViewCoreIdeasBoardModal = ({ show, hide, assignments, blockType } :  Props) => {

  const navigate = useNavigate()

  if (!show) return null
  if (!assignments) return <BeatLoader />

  const viewCoreIdea = (assignment: AssignmentResponse) => {
    navigate(`/dashboard/teacher/science/${toProductString(blockType)}/assignments/preview`, {
        state: {
            assignment: assignment,
            origin: "assignments",
            blockType: blockType,
        } as AssignmentPreviewStateProps
    })
    localStorage.setItem(CORE_IDEA_VIEW_OPEN_KEY, "true")
  }

  const cardColor = 'rgba(64, 74, 189, 0.89)'

  return (
    <Modal show={show} onHide={hide} size="xl">
        <Modal.Header className="border-0" closeButton>
            <h3 className="w-100 text-center fw-bold"> <i className="fa-solid fa-chess-board me-1" /> Assigned Core Ideas</h3>
        </Modal.Header>
        <Modal.Body className="text-center">
            <Row className={`${styles.coreIdeasContainer} container-fluid d-flex flex-wrap gap-2`}>
              <p className="text-center text-muted fw-bold fs-5 p-0 mb-3">Click on a Core Idea card to view the components</p>
              {assignments.length === 0 && <p>You haven't assigned core ideas yet.</p>}
              {assignments.map((assignment) => {
                const review = assignment.review
                return ( 
                  <Col
                    key={`core-idea-${assignment.id}`}
                    className={`${styles.coreIdeaCard} mb-3 bg-primary`}
                    style={{backgroundImage: `linear-gradient(0deg, ${cardColor}), url(${review.image})`, backgroundSize: "cover", backgroundPosition: "center"}}
                    xs={3}
                    onClick={() => viewCoreIdea(assignment)}
                  >
                      {review.label && <p className="fs-5 fw-bold mb-0" dangerouslySetInnerHTML={{ __html: review.label }}></p>}
                        <p className={`${review.label ? "fs-8" : "fs-5"} fw-bold mb-0`}>{review.title ?? ""}</p>
                        <div className="d-flex flex-row position-absolute bottom-0 start-0">
                          <i className={`fas fa-circle opacity-25 ms-2 mb-2`}></i>
                          <i className={`fas fa-circle opacity-25 ms-2 mb-2`}></i>
                          <i className={`fas fa-circle opacity-25 ms-2 mb-2`}></i>
                        </div>
                  </Col>
                )
              })}
            </Row>
        </Modal.Body>
    </Modal>
  )
}

export default ViewCoreIdeasBoardModal
